module.exports = __webpack_public_path__ + "static/rocket-4fedf7e16b99529b5c6bf84b447afae7.svg";